// extracted by mini-css-extract-plugin
module.exports = {"content":"MoreFilters_content__28ZtA","header":"MoreFilters_header__3QSBJ","body":"MoreFilters_body__3pCc-","footer":"MoreFilters_footer__yRf5M","title":"MoreFilters_title__3SIvP"};